const config = {
    api_base_url : process.env.REACT_APP_API_URL,
    use_dummy : process.env.REACT_APP_USE_DUMMY,
    current_version : Number(process.env.REACT_APP_VERSION)
}

export default config;